import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import CreatorInfo from './CreatorInfo';

function SortableCreator({ member, selecting, selected, onSelect, onRemove, disabled }) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: member.User_id,
    disabled
  });
  const name = `${member.user.name} (${member.User_id})`;
  return (
    <article
      ref={setNodeRef}
      className={`circle-creator-card${selected ? ' selected' : ''}${isDragging ? ' dragging' : ''}`}
      style={{ transform: CSS.Transform.toString(transform), transition }}
    >
      <CreatorInfo user={member.user} />
      {selecting && (
        <label className='circle-creator-select'>
          <input type='checkbox' aria-label={`Select ${name}`} checked={selected} onChange={onSelect} />
        </label>
      )}
      <div className='circle-creator-actions'>
        <button
          ref={setActivatorNodeRef}
          className='circle-creator-grip'
          {...attributes}
          {...listeners}
          disabled={disabled}
          aria-label={`Drag ${name} to reorder`}
          title='Drag to reorder'
        >
          ⠿
        </button>
        <button className='circle-creator-remove' aria-label={`Remove ${name}`} title='Remove creator' onClick={onRemove}>
          ×
        </button>
      </div>
    </article>
  );
}

SortableCreator.propTypes = {
  member: PropTypes.object.isRequired,
  selecting: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default SortableCreator;
